export default {
  ON_SUBMIT: 'ON_SUBMIT',
  ON_CANCEL: 'ON_CANCEL',
  ON_FOCUS: 'ON_FOCUS',
  FOCUS_PREV: 'FOCUS_PREV',
  FOCUS_NEXT: 'FOCUS_NEXT'
};